import { render, staticRenderFns } from "./LoadingMainPanel.vue?vue&type=template&id=634bc8fa&"
import script from "./LoadingMainPanel.vue?vue&type=script&lang=js&"
export * from "./LoadingMainPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports